import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../client";
import type { Me } from "../types";

export const ME_KEY = ["me"] as const;

export function useMe(): UseQueryResult<Me | null, ApiError> {
  return useQuery<Me | null, ApiError>({
    queryKey: ME_KEY,
    queryFn: async ({ signal }) => {
      try {
        return await apiFetch<Me>("/api/me", { signal });
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
  });
}
